export default "__VITE_ASSET__CqLzFeGr__"